import { COOKIES_STORAGE_KEY, STORAGE_KEY, BACKEND_VERSION_HEADER } from '@/constants/storage';

const LocalStorageService = {
  getToken() {
    const item = localStorage.getItem(STORAGE_KEY);

    if (!item) {
      return null;
    }

    const { token } = JSON.parse(item);

    return token || null;
  },

  clearStorage() {
    localStorage.removeItem(STORAGE_KEY);
  },

  setBackendVersion(version) {
    localStorage.setItem(BACKEND_VERSION_HEADER, version);
  },

  getBackendVersion() {
    const backendVersion = localStorage.getItem(BACKEND_VERSION_HEADER);

    try {
      return JSON.parse(backendVersion) ? backendVersion : null;
    } catch (error) {
      return null;
    }
  },

  getAcceptCookiesConsent() {
    return JSON.parse(localStorage.getItem(COOKIES_STORAGE_KEY)) || false;
  },

  setAcceptCookiesConsent(acceptCookies) {
    return localStorage.setItem(COOKIES_STORAGE_KEY, acceptCookies);
  },

  saveTestData(testData) {
    localStorage.setItem('test-debug', JSON.stringify(testData));
  }
};

export default LocalStorageService;
